import { useRef } from 'react';

import { Button } from 'components/Button';

type FileInputProps = {
  onChange: (e: any) => void; // eslint-disable-line
  label?: string;
  // file types the picker offers, e.g. '.xlsx'
  accept?: string;
  disabled?: boolean;
};

export function FileInput(props: FileInputProps): React.ReactElement {
  const { onChange, label = 'UPLOAD NEW IMAGE', accept, disabled } = { ...props };

  const hiddenFileInput = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        iconLeft="FiPlus"
        motive="primaryBlack"
        fontFamily="LFT Zeno Condensed"
        scale="base"
        disabled={disabled}
        onClick={() => hiddenFileInput.current!.click()}
      >
        {label}
      </Button>

      <input
        data-testid="file-input"
        type="file"
        accept={accept}
        ref={hiddenFileInput}
        onChange={(e) => onChange(e)}
        style={{ display: 'none' }}
      />
    </>
  );
}
